module.exports = __webpack_public_path__ + "img/gettyimages-746114359-1024-x-1024-ok-medium.acd1a6a1.png";